import React from "react";
import { MdCheckCircle, MdPending } from 'react-icons/md';
import Card from '../components/UI/Card';

const FormInfoCard = (props) => {

    let formInfoStatus = "";
    if(props.estado === 'completado'){
        formInfoStatus = <span className="badge rounded-pill text-bg-success align-middle" style={{fontSize: '0.85rem'}}><MdCheckCircle />&nbsp;Completado</span>;
    } else if(props.estado === 'pendiente'){
        formInfoStatus = <span className="badge rounded-pill text-bg-warning text-black-50 align-middle" style={{fontSize: '0.85rem'}}><MdPending />&nbsp;Pendiente</span>;
    }


    const onClick = props.disabled ? () => {}:props.onClick;
    return (
        <Card 
            style={{...props.style, cursor: props.disabled ? 'default':'pointer'}} 
            className={props.className} 
            disabled={props.disabled} 
            onClick={onClick}
            hover={props.onHover} >
            <div className="d-flex user-select-none" style={{height: "100%"}}>
                <h2 className='d-flex align-items-center text-black-50 px-3 py-2'>
                    <props.icon />
                </h2>
                <div className="vr my-2"></div>
                <div className="container py-3">
                    <div className="row px-3">
                        <h1 className="display-6" style={{fontSize: '1.5rem'}}>
                            <span className={`${props.disabled ? 'text-black-50':''}`}>{props.titulo}</span>
                            <br />
                            {!props.disabled && formInfoStatus}
                        </h1>
                        <p style={{textAlign: 'justify'}} className={`mb-0 ${props.disabled ? 'text-black-50':''}`}>
                            {props.texto}
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default FormInfoCard;